import React, { useEffect } from "react";

import "./Modal.css";

function Modal({ zIndex, isOpen, onClose, importModalStyles, children }) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  return (
    <div
      className={isOpen ? (zIndex ? "modal2" : "modal1") : "d-none"}
      onClick={() => (onClose ? onClose() : "")}
    >
      <div
        className={`${
          importModalStyles
            ? "modal_content_import"
            : "modal_content custom-scroll"
        }`}
        onClick={(event) => event.stopPropagation()}
      >
        {isOpen && children}
      </div>
    </div>
  );
}

export default Modal;
